import React from 'react';
import PropTypes from 'prop-types';
import * as AuthenticationAction from './action/authenticationAction';
import { LogoutTimeoutInterceptorService } from './interceptors/logoutTimeoutInterceptor';
import ReactDOM from 'react-dom';
import { Portal } from './component/Portal/Portal';
import { assign } from 'lodash';
import { loadSignalRService } from './services/signalR/loader';
import { InformationPopupContext } from './component/InformationPopupContext/InformationPopupContext';
import { AccountOrganisationDataService } from './services/userOrganisation/AccountOrganisationDataService';
import { AppBanner } from './views/AppBanner/AppBanner';
import { AppBannerService } from './services/AppBannerService';

var AppAction = require('./action/appAction'),
  Ui = Esk.Helper.Ui,
  AppStore = require('./store/appStore'),
  ModuleStore = require('./store/moduleStore'),
  AccountStore = require('./store/accountStore'),
  ModuleAction = require('./action/moduleAction'),
  AccountAction = require('./action/accountAction'),
  AuthenticationStore = require('./store/authenticationStore');


var AppContent = React.createClass({

  propTypes: {
    refreshContent: PropTypes.bool
  },

  getDefaultProps() {
    return {
      refreshContent: true
    }
  },

  shouldComponentUpdate(nextProps, nextState) {
    return !!nextProps.refreshContent;
  },

  render() {
    return (this.props.children)
  }

});


var AppContext = React.createClass({

  propTypes: {
    toggleGlobalSpinner: PropTypes.func.isRequired
  },

  refreshContent: true,

  childContextTypes: {
    showAppPopover: PropTypes.func,
    showAppPopoverObject: PropTypes.func,
    hideAppPopover: PropTypes.func,
    setCurrentModule: PropTypes.func,
    showBackdrop: PropTypes.func,
    hideBackdrop: PropTypes.func
  },


  getChildContext() {
    var self = this;

    return {
      showAppPopover(x, y, content, title, position) {
        if (!isFinite(x) || !isFinite(y)) return;
        self.refreshContent = false;
        self.setState({
          appPopover: {
            x: x,
            y: y,
            content: content,
            title: title,
            position: position,
            width: null,
            height: null,
            autoHide: false
          }
        })
      },
      showAppPopoverObject(popoverObject) {
        self.refreshContent = false;
        self.setState({appPopover: assign({}, popoverObject)});
      },
      hideAppPopover() {
        this.refreshContent = false;
        self.setState({appPopover: null});
      },
      setCurrentModule(code) {
        if (ModuleStore.isModuleAvailable(code)) {
          AppStore.cleanAppErrorState();
          ModuleStore.setCurrentModule(code);
          return true;
        }

        return false;
      },

      showBackdrop() {
        this.refreshContent = false;
        self.setState({
          showBackdrop: true
        });
      },

      hideBackdrop() {
        this.refreshContent = false;
        self.setState({
          showBackdrop: false
        });
      },
    }
  },

  getInitialState() {
    return {
      isModuleListReady: false,
      isAccountReady: false,
      moduleList: ModuleStore.getModuleList(),
      currentModule: ModuleStore.getCurrentModule(),
      appPopover: null,
      showBackdrop: false
    }
  },

  async componentWillMount() {
    this._toggleGlobalSpinner(false);

    AccountOrganisationDataService.getInstance(AccountStore);
    ModuleStore.addChangeListener(this._onModuleStoreChange);
    AccountStore.addChangeListener(this._onAccountStoreChange);
    AppStore.addChangeLangListener(this._onAppStoreLanguageChange);
    AppStore.addSpinnerListener(this._toggleGlobalSpinner);
    AuthenticationStore.addActAsSignOutListener(this._onActAsSignOut);

    if (AuthenticationStore.isLoggedIn()) {
      try {
        this._toggleGlobalSpinner(true);
        await Promise.all([
          AccountAction.getAccount(),
        ModuleAction.getModuleList(),
        AccountAction.getPermissions(),
        AppAction.getAvailableLanguages().then(() => {
          AccountAction.getCurrentProfileSettings()
        })]);
        AppBannerService.getInstance().init();
        if (AuthenticationStore.shouldLogoutOnTimeout()) {
          const logoutTimeout = LogoutTimeoutInterceptorService.getInstance();
          logoutTimeout.registerLogoutEvent(AuthenticationAction.redirectToLogout);
        }
        loadSignalRService().then(service => { service.getInstance(AuthenticationStore.getToken()); });
      } catch (error) {
        AuthenticationAction.logoutOnError();
        this.forceUpdate();
      } finally {
        this._toggleGlobalSpinner(false);
      }
    }
  },

  componentWillUnmount: function () {
    ModuleStore.removeChangeListener(this._onModuleStoreChange);
    AppStore.removeChangeLangListener(this._onAppStoreLanguageChange);
    AppStore.removeSpinnerListener(this._toggleGlobalSpinner);
    AuthenticationStore.removeActAsSignOutListener(this._onActAsSignOut());
  },

  _onModuleStoreChange: function () {
    this.setState({
      moduleList: ModuleStore.getModuleList(),
      isModuleListReady: ModuleStore.getModuleListReadyStatus()
    });
  },

  _onAccountStoreChange: function () {
    this.setState({
      isAccountReady: AccountStore.getAccount()
    });
  },


  _onAppStoreLanguageChange: function () {
    AppAction.setLayoutOrientationByLanguage(AppStore.getCurrentLanguageCode());
  },

  _onActAsSignOut: function () {
    AccountAction.getCurrentProfileSettings();
  },

  render() {
    if (!this._shouldChildrenBeRendered()) return null;

    var isContentRefreshed = this.refreshContent;
    this.refreshContent = true;
    return (
      <div
        className="esk-app-context"
        onClick={this._contextClickEventHandler}
      >

        <AppBanner />

        <Portal>
          <AppContent refreshContent={isContentRefreshed}>
            <InformationPopupContext>
              {this.props.children}
            </InformationPopupContext>
          </AppContent>
        </Portal>
        {this._getPopover()}
        {this._getBackdrop()}
      </div>
    )
  },

  _toggleGlobalSpinner(state) {
    this.props.toggleGlobalSpinner(state);
  },

  _shouldChildrenBeRendered() {
    if (!AuthenticationStore.isLoggedIn()) {
      return true;
    }
    return this.state.isModuleListReady && this.state.isAccountReady;
  },

  _getBackdrop() {
    if (this.state.showBackdrop) {
      return <div className="modal-backdrop fade in"/>;
    }
  },

  _getPopover() {
    var {appPopover} = this.state;

    return appPopover
      ? (
        <Ui.AppPopover
          className={appPopover.className}
          x={appPopover.x}
          y={appPopover.y}
          width={appPopover.width}
          height={appPopover.height}
          position={appPopover.position}
          title={appPopover.title}
          ref="AppPopover"
        >
          {appPopover.content}
        </Ui.AppPopover>
      )
      : null;
  },

  _contextClickEventHandler(event) {
    this._setPopoverState();
    var popoverElement = ReactDOM.findDOMNode(this.refs["AppPopover"]);
    if (this.state.appPopover && popoverElement && !popoverElement.contains(event.target)) {
      this.refreshContent = false;
      this.setState({appPopover: null});
    }
  },

  /**!!!! deprecated feature -> to delete */
  _setPopoverState() {
    var activePopover = AppStore.getCurrentPopover();
    if (!activePopover) return;

    if (!activePopover.contains(event.target)) {
      AppAction.setPopover(event, null);
    }
  }
});

module.exports = AppContext;
